import React from 'react';

const SelectOption = ({ index, cursor, setCursor, setKeyWord, setHeight, searchRefFocus, searchable, value, selectedValue, multiselect, handleClick, children, ...props }) => {
    const handleFunction = (value) => {
        if (multiselect) {
            let arrayOfValue = [];

            if (selectedValue.includes(value)) {
                arrayOfValue = [...selectedValue.filter(e => e !== value)];
            } else {
                arrayOfValue = [...selectedValue, value];
            }

            handleClick({ target: { value: arrayOfValue } });
            setKeyWord('');
            setHeight(0);
            callOutFunctions();
        } else {
            handleClick({ target: { value } });
        }
    }

    const callOutFunctions = () => {
        if (multiselect && !searchable) {
            setCursor(index);
            return;
        }

        if (searchable) {
            setCursor(index);
            searchRefFocus();
        }
    }

    return (
        <li
            role="option"
            aria-selected={(selectedValue && selectedValue === value)}
            className={`relative ${(index === cursor ? 'active' : '')} ${(selectedValue && selectedValue === value ? 'bg-purple-2' : '')}`} {...props}
            onClick={() => handleFunction(value)}
            onMouseMove={() => multiselect ? callOutFunctions() : {}} data-value={value}
        >
            {children}
            <span className='absolute inset-0' aria-hidden='true' />
        </li>
    );
};

export default SelectOption;
